export const FRAMEWORKS = [
  {
    key: 'TCFD',
    title: 'TCFD',
    name: 'Task Force on Climate-related Financial Disclosures',
    description: 'Create a climate-related financial disclosure narrative across governance, strategy, risk management, metrics and targets.',
    color: 'primary',
  },
  {
    key: 'SECR',
    title: 'SECR',
    name: 'Streamlined Energy and Carbon Reporting',
    description: 'Prepare an annual energy and carbon statement with emissions, intensity metrics, methodology and approval details.',
    color: 'success',
  },
  {
    key: 'CSRD',
    title: 'CSRD',
    name: 'Corporate Sustainability Reporting Directive',
    description: 'Draft sustainability disclosures with impact, risk, opportunity and value-chain context.',
    color: 'info',
  },
  {
    key: 'TCFD-SAMPLE-2',
    title: 'TCFD',
    name: 'Task Force on Climate-related Financial Disclosures',
    description: 'Detailed TCFD reporting template with structured risk, scenario analysis, metrics and target inputs.',
    color: 'primary',
  },
];

export const REPORT_TYPE_FILTERS = [
  {
    key: 'TCFD',
    title: 'TCFD',
    name: 'Task Force on Climate-related Financial Disclosures',
  },
  {
    key: 'SECR',
    title: 'SECR',
    name: 'Streamlined Energy and Carbon Reporting',
  },
  {
    key: 'CSRD',
    title: 'CSRD',
    name: 'Corporate Sustainability Reporting Directive',
  },
];

export const REPORT_TYPE_CREATE_OPTIONS = [
  {
    key: 'TCFD-SAMPLE-2',
    title: 'TCFD',
    name: 'Task Force on Climate-related Financial Disclosures',
    description: 'Detailed TCFD reporting template with structured risk, scenario analysis, metrics and target inputs.',
  },
  {
    key: 'SECR',
    title: 'SECR',
    name: 'Streamlined Energy and Carbon Reporting',
    description: 'Prepare an annual energy and carbon statement with emissions, intensity metrics, methodology and approval details.',
  },
  {
    key: 'CSRD',
    title: 'CSRD',
    name: 'Corporate Sustainability Reporting Directive',
    description: 'Draft sustainability disclosures with impact, risk, opportunity and value-chain context.',
  },
];

export const REPORT_STATUSES = {
  draft: { label: 'Draft', variant: 'secondary' },
  review: { label: 'Ready for Review', variant: 'warning' },
  completed: { label: 'Completed', variant: 'success' },
  finalized: { label: 'Finalized', variant: 'primary' },
};

export const DATA_SET_FIELDS = [
  { id: '1', section: 'Governance', dataField: 'Board Oversight Structure', lastUpdatedUser: 'Sarah Johnson', lastUpdatedDate: '2024-11-20', status: 'complete' },
  { id: '2', section: 'Governance', dataField: 'Management Responsibilities', lastUpdatedUser: 'Michael Chen', lastUpdatedDate: '2024-11-18', status: 'complete' },
  { id: '3', section: 'Strategy', dataField: 'Climate Transition Approach', lastUpdatedUser: 'Sarah Johnson', lastUpdatedDate: '2024-11-15', status: 'complete' },
  { id: '4', section: 'Strategy', dataField: 'Emissions Baseline (Scope 1)', lastUpdatedUser: 'Emily Watson', lastUpdatedDate: '2024-11-10', status: 'complete' },
  { id: '5', section: 'Strategy', dataField: 'Emissions Baseline (Scope 3)', lastUpdatedUser: 'System', lastUpdatedDate: '2024-10-15', status: 'missing' },
  { id: '6', section: 'Risk Management', dataField: 'Risk Identification Process', lastUpdatedUser: 'David Martinez', lastUpdatedDate: '2024-11-12', status: 'complete' },
  { id: '7', section: 'Metrics & Targets', dataField: 'Energy Consumption Data', lastUpdatedUser: 'System', lastUpdatedDate: '2024-09-20', status: 'missing' },
  { id: '8', section: 'Metrics & Targets', dataField: 'Net Zero Target Timeline', lastUpdatedUser: 'Sarah Johnson', lastUpdatedDate: '2024-11-20', status: 'complete' },
];

export const AUDIT_HISTORY = [
  { version: 'v1.5', lastUpdateDate: '2024-11-28 14:32', lastUpdatedUser: 'Sarah Johnson', updatedSections: ['Governance', 'Strategy'] },
  { version: 'v1.4', lastUpdateDate: '2024-11-25 10:15', lastUpdatedUser: 'Michael Chen', updatedSections: ['Metrics & Targets'] },
  { version: 'v1.3', lastUpdateDate: '2024-11-22 16:45', lastUpdatedUser: 'Sarah Johnson', updatedSections: ['Risk Management', 'Metrics & Targets'] },
  { version: 'v1.2', lastUpdateDate: '2024-11-20 09:20', lastUpdatedUser: 'Emily Watson', updatedSections: ['Governance', 'Strategy', 'Risk Management'] },
  { version: 'v1.1', lastUpdateDate: '2024-11-18 11:30', lastUpdatedUser: 'David Martinez', updatedSections: ['Strategy'] },
  { version: 'v1.0', lastUpdateDate: '2024-11-15 08:00', lastUpdatedUser: 'Sarah Johnson', updatedSections: ['All Sections - Initial Creation'] },
];

const dataQuality = (status = 'Actual') => ({
  status,
  source: 'CarbonView',
  timestamp: '2026-04-16T09:30:00',
});

export const createMockReports = () => [
  {
    id: 'NR-001',
    name: 'Climate Disclosure Report - 2024 Annual',
    framework: 'TCFD',
    reportingPeriod: 'January 2024 - December 2024',
    startDate: '2024-01',
    endDate: '2024-12',
    status: 'draft',
    createdBy: 'Sarah Johnson',
    finalizedBy: null,
    createdDate: '2024-11-15',
    updatedAt: '2026-04-12T09:30:00',
  },
  {
    id: 'NR-002',
    name: 'Sustainability Report - Q1 FY25',
    framework: 'TCFD',
    reportingPeriod: 'April 2024 - March 2025',
    startDate: '2024-04',
    endDate: '2025-03',
    status: 'completed',
    createdBy: 'Michael Chen',
    finalizedBy: null,
    createdDate: '2024-10-22',
    updatedAt: '2026-03-28T14:15:00',
  },
  {
    id: 'NR-003',
    name: 'ESG Disclosure Report - 2024',
    framework: 'CSRD',
    reportingPeriod: 'January 2024 - December 2024',
    startDate: '2024-01',
    endDate: '2024-12',
    status: 'draft',
    createdBy: 'David Martinez',
    finalizedBy: null,
    createdDate: '2024-09-10',
    updatedAt: '2026-02-18T11:10:00',
  },
  {
    id: 'NR-004',
    name: 'Climate Financial Disclosure - FY24',
    framework: 'TCFD',
    reportingPeriod: 'July 2023 - June 2024',
    startDate: '2023-07',
    endDate: '2024-06',
    status: 'finalized',
    createdBy: 'Emily Watson',
    finalizedBy: 'Sarah Johnson',
    createdDate: '2024-08-05',
    updatedAt: '2026-01-24T10:00:00',
  },
  {
    id: 'NR-005',
    name: 'TCFD Sample 2 Report - 2024',
    framework: 'TCFD-SAMPLE-2',
    reportingPeriod: 'January 2024 - December 2024',
    startDate: '2024-01',
    endDate: '2024-12',
    status: 'draft',
    createdBy: 'Sarah Johnson',
    finalizedBy: null,
    createdDate: '2024-11-20',
    updatedAt: '2026-01-18T12:00:00',
  },
  {
    id: 'NR-006',
    name: 'Acme Corp SECR Report - 2024',
    framework: 'SECR',
    reportingPeriod: 'January 2024 – December 2024',
    startDate: '2024-01',
    endDate: '2024-12',
    status: 'draft',
    createdBy: 'Sarah Johnson',
    finalizedBy: null,
    createdDate: '2024-11-25',
    updatedAt: '2026-04-10T09:00:00',
  },
];

export const createSections = (framework, reportingPeriod) => {
  if (framework === 'TCFD' || framework === 'TCFD-SAMPLE-2') {
    return [
      {
        id: 'introduction',
        name: '1. Introduction',
        completed: false,
        systemFields: [],
        editableFields: [
          { id: 'reporting-boundary', name: 'Reporting Boundary', value: '', type: 'text', required: true, helpText: 'Enter the reporting boundary (e.g., Group / UK Operations / Global Operations)' },
          { id: 'scenario-year', name: 'Scenario Coverage Year', value: '', type: 'text', required: false, helpText: 'Enter the scenario coverage year (e.g., 2030)' },
        ],
      },
      {
        id: 'governance',
        name: '2. Pillar 1 - Governance',
        completed: false,
        systemFields: [],
        editableFields: [
          { id: 'board-oversight', name: '2.1 Board Oversight', value: '', type: 'richtext', required: false, helpText: 'Describe board oversight of climate-related risks and opportunities' },
          { id: 'review-frequency', name: 'Frequency of Review', value: '', type: 'text', required: false, helpText: 'How often does the board review climate matters? (e.g., Quarterly / Bi-annually / Annually)' },
          { id: 'management-role', name: '2.2 Management\'s Role', value: '', type: 'textarea', required: false, helpText: 'Specify role titles, e.g., Sustainability Lead, COO, ESG Manager' },
          { id: 'governance-structure', name: '2.3 Governance Structure', value: '', type: 'textarea', required: false, helpText: 'Insert or describe governance diagram' },
        ],
      },
      {
        id: 'strategy',
        name: '3. Pillar 2 - Strategy',
        completed: false,
        systemFields: [
          { id: 'emissions-baseline', name: 'Emissions Baseline (for risks assessment)', value: 788.2, unit: 'tCO₂e', quality: dataQuality() },
        ],
        editableFields: [
          { id: 'transition-risks-desc', name: 'Transition Risks - Description', value: '', type: 'textarea', required: false, helpText: 'Describe transition risks' },
          { id: 'transition-risks-time', name: 'Transition Risks - Time Horizon', value: '', type: 'text', required: false, helpText: 'e.g., Short-term (0-3 years), Medium-term (3-10 years), Long-term (10+ years)' },
          { id: 'transition-risks-impact', name: 'Transition Risks - Financial Impact', value: '', type: 'text', required: false, helpText: 'Estimated financial impact' },
          { id: 'transition-risks-supporting-data', name: 'Transition Risks - Supporting Data', value: '', type: 'textarea', required: false, helpText: 'e.g., Emissions/Energy Baselines' },
          { id: 'physical-risks-desc', name: 'Physical Risks - Description', value: '', type: 'textarea', required: false, helpText: 'Describe physical climate risks' },
          { id: 'physical-risks-time', name: 'Physical Risks - Time Horizon', value: '', type: 'text', required: false, helpText: 'Time horizon for physical risks' },
          { id: 'physical-risks-impact', name: 'Physical Risks - Financial Impact', value: '', type: 'text', required: false, helpText: 'Estimated financial impact' },
          { id: 'physical-risks-supporting-data', name: 'Physical Risks - Supporting Data', value: '', type: 'textarea', required: false, helpText: 'Physical risk data source' },
          { id: 'opportunities-desc', name: 'Opportunities - Description', value: '', type: 'textarea', required: false, helpText: 'Describe efficiency/low-carbon opportunities' },
          { id: 'opportunities-time', name: 'Opportunities - Time Horizon', value: '', type: 'text', required: false, helpText: 'Time horizon for opportunities' },
          { id: 'opportunities-impact', name: 'Opportunities - Financial Impact', value: '', type: 'text', required: false, helpText: 'Estimated financial impact' },
          { id: 'opportunities-supporting-data', name: 'Opportunities - Supporting Data', value: '', type: 'textarea', required: false, helpText: 'Energy reduction / project data' },
          { id: 'business-impact', name: '3.3 Impact on Business & Strategy', value: '', type: 'richtext', required: false, helpText: 'Summary of business model impacts' },
          { id: 'scenario-analysis', name: '3.4 Scenario Analysis', value: '', type: 'richtext', required: false, helpText: 'Describe scenario analysis undertaken' },
          { id: 'scenario-variables', name: 'Key Variables Included', value: '', type: 'textarea', required: false, helpText: 'e.g., Carbon price, heat exposure, transition costs' },
          { id: 'scenario-results', name: 'Summary of Results', value: '', type: 'textarea', required: false, helpText: 'Qualitative or quantitative outputs from scenario analysis' },
        ],
      },
      {
        id: 'risk-management',
        name: '4. Pillar 3 - Risk Management',
        completed: false,
        systemFields: [],
        editableFields: [
          { id: 'risk-identification', name: '4.1 Identification & Assessment', value: '', type: 'richtext', required: false, helpText: 'Describe how climate risks are integrated (e.g., enterprise risk management framework)' },
          { id: 'risk-management-controls', name: '4.2 Management of Climate Risks', value: '', type: 'richtext', required: false, helpText: 'Controls in place (e.g., building resilience measures, energy plans)' },
          { id: 'risk-integration', name: '4.3 Integration with Overall Risk Framework', value: '', type: 'richtext', required: false, helpText: 'Links to risk register and describe integration' },
        ],
      },
      {
        id: 'metrics-targets',
        name: '5. Pillar 4 - Metrics & Targets',
        completed: false,
        systemFields: [
          { id: 'scope1-total', name: 'Scope 1 Emissions', value: 46.2, unit: 'tCO₂e', quality: dataQuality('Estimated') },
          { id: 'scope2-total', name: 'Scope 2 Emissions', value: 462, unit: 'tCO₂e', quality: dataQuality() },
          { id: 'scope3-total', name: 'Scope 3 Emissions', value: 280, unit: 'tCO₂e', quality: dataQuality('Estimated') },
          { id: 'total-emissions', name: 'Total GHG Emissions', value: 788.2, unit: 'tCO₂e', quality: dataQuality() },
          { id: 'electricity-kwh', name: 'Electricity Consumption', value: 892500, unit: 'kWh', quality: dataQuality() },
          { id: 'gas-kwh', name: 'Gas Consumption', value: 163800, unit: 'kWh', quality: dataQuality('Estimated') },
          { id: 'transport-fuel-kwh', name: 'Transport Fuel', value: 125000, unit: 'kWh', quality: dataQuality('Estimated') },
          { id: 'intensity-value', name: 'Intensity Metric Result', value: 3.2, unit: 'tCO₂e per FTE', quality: dataQuality() },
          { id: 'intensity-yoy-change', name: 'Year-on-Year Change', value: -8.5, unit: '%', quality: dataQuality() },
          { id: 'progress-tracking', name: 'Current Performance vs Target', value: 'On track: 20% achieved by 2025', unit: '', quality: dataQuality() },
        ],
        editableFields: [
          { id: 'intensity-metric', name: '5.3 Selected Intensity Metric', value: '', type: 'select', required: false, helpText: 'Required by TCFD', options: ['tCO₂e per FTE', 'tCO₂e per revenue', 'tCO₂e per m²'] },
          { id: 'net-zero-commitment', name: '5.4 Net Zero Commitment', value: '', type: 'text', required: false, helpText: 'Has the organization committed to Net Zero?' },
          { id: 'interim-targets-reduction', name: '5.5 Interim Targets - Target Reduction (%)', value: '', type: 'number', required: false, helpText: 'Enter the target reduction percentage (e.g., 50 for 50% reduction)' },
          { id: 'interim-targets-year', name: '5.5 Interim Targets - Target Year', value: '', type: 'number', required: false, helpText: 'Enter the target year (YYYY format, e.g., 2030)' },
        ],
      },
      {
        id: 'additional-disclosures',
        name: '6. Additional Disclosures',
        completed: false,
        systemFields: [
          { id: 'conversion-factors', name: 'Conversion Factors Used', value: 'DEFRA UK Government Conversion Factors 2023', unit: '', quality: dataQuality() },
        ],
        editableFields: [
          { id: 'boundaries-assumptions', name: '6.1 Boundaries & Assumptions', value: '', type: 'richtext', required: false, helpText: 'Operational boundaries, exclusions' },
          { id: 'data-gaps', name: '6.2 Limitations - Data Gaps', value: '', type: 'textarea', required: false, helpText: 'Describe Scope 3 or supplier gaps' },
          { id: 'estimation-methods', name: '6.2 Limitations - Estimation Methods', value: '', type: 'textarea', required: false, helpText: 'Describe estimation methods used' },
          { id: 'forward-looking-statement', name: '6.3 Forward-Looking Statements', value: '', type: 'textarea', required: false, helpText: 'Standard caution wording for forward-looking statements' },
        ],
      },
      {
        id: 'appendix',
        name: '7. Appendix',
        completed: false,
        systemFields: [
          { id: 'detailed-ghg-tables', name: 'Detailed GHG Tables', value: 'Activity data, emission factors, calculation outputs from CarbonView', unit: '', quality: dataQuality() },
        ],
        editableFields: [
          { id: 'scenario-inputs', name: '7.2 Additional Scenario Details', value: '', type: 'richtext', required: false, helpText: 'Inputs & assumptions for scenario analysis' },
          { id: 'governance-chart', name: '7.3 Governance Chart', value: '', type: 'textarea', required: false, helpText: 'Insert visual or description of governance structure' },
        ],
      },
    ];
  }

  if (framework === 'SECR') {
    return [
      {
        id: 'executive-summary',
        name: '1. Executive Summary',
        completed: false,
        systemFields: [
          { id: 'total-emissions', name: 'Total Carbon Emissions', value: 788.2, unit: 'tCO₂e', quality: dataQuality() },
          { id: 'yoy-change', name: 'Year-on-Year Change', value: -12.3, unit: '%', quality: dataQuality() },
          { id: 'intensity-ratio-value', name: 'Operational Intensity Ratio', value: 3.89, unit: 'tCO₂e/FTE', quality: dataQuality() },
        ],
        editableFields: [
          { id: 'org-boundary', name: 'Organisation Boundary', value: '', type: 'text', required: true, helpText: 'e.g., UK operations only / Global legal entities' },
        ],
      },
      {
        id: 'annual-figures',
        name: '2. Annual Reporting Figures',
        completed: false,
        systemFields: [
          { id: 'scope1-gas-fuels', name: 'Scope 1 - Gas & Fuels', value: 145620, unit: 'kWh', quality: dataQuality() },
          { id: 'scope2-electricity', name: 'Scope 2 - Electricity', value: 298450, unit: 'kWh', quality: dataQuality() },
          { id: 'scope3-travel', name: 'Scope 3 - Business Travel (kWh equivalent)', value: 52180, unit: 'kWh', quality: dataQuality('Estimated') },
          { id: 'total-energy', name: 'Total Energy Consumption', value: 496250, unit: 'kWh', quality: dataQuality() },
          { id: 'scope1-emissions', name: 'Scope 1 Emissions', value: 267.8, unit: 'tCO₂e', quality: dataQuality() },
          { id: 'scope2-emissions', name: 'Scope 2 Emissions', value: 401.2, unit: 'tCO₂e', quality: dataQuality() },
          { id: 'scope3-emissions', name: 'Scope 3 Emissions', value: 119.2, unit: 'tCO₂e', quality: dataQuality('Estimated') },
          { id: 'total-emissions-section2', name: 'Total Emissions', value: 788.2, unit: 'tCO₂e', quality: dataQuality() },
          { id: 'intensity-calculated', name: 'Intensity Value', value: 3.89, unit: 'tCO₂e/FTE', quality: dataQuality() },
          { id: 'intensity-yoy', name: 'YOY Change', value: -8.5, unit: '%', quality: dataQuality() },
        ],
        editableFields: [
          { id: 'conversion-factor-mileage', name: 'Conversion Factor (mileage to kWh)', value: '', type: 'number', required: false, helpText: 'Enter the conversion factor to transfer from mileage to kWh' },
          { id: 'notes-exclusions', name: 'Notes/Exclusions', value: '', type: 'textarea', required: false, helpText: 'e.g., Refrigerants not included due to data limits' },
          { id: 'intensity-metric-selected', name: 'Selected Intensity Ratio', value: '', type: 'select', required: true, helpText: 'Select the intensity ratio for reporting', options: ['tCO₂e per FTE', 'tCO₂e per £m turnover', 'tCO₂e per m²'] },
        ],
      },
      {
        id: 'energy-efficiency',
        name: '3. Energy Efficiency Actions',
        completed: false,
        systemFields: [],
        editableFields: [
          { id: 'measures-implemented', name: 'Energy Efficiency Measures Implemented', value: '', type: 'richtext', required: false, helpText: 'Describe measures implemented in reporting year' },
          { id: 'quantifiable-savings', name: 'Quantifiable Savings', value: '', type: 'textarea', required: false, helpText: 'Any quantifiable savings achieved' },
          { id: 'planned-initiatives', name: 'Planned Initiatives', value: '', type: 'richtext', required: false, helpText: 'Planned measures for next year' },
        ],
      },
      {
        id: 'methodology',
        name: '4. Methodology',
        completed: false,
        systemFields: [
          { id: 'conversion-factors', name: 'Conversion Factors Used', value: 'DEFRA UK Government Conversion Factors 2023', unit: '', quality: dataQuality() },
          { id: 'emission-factor-source', name: 'Emission Factor Source', value: 'DEFRA 2023', unit: '', quality: dataQuality() },
        ],
        editableFields: [
          { id: 'reporting-boundary-method', name: 'Reporting Boundary', value: '', type: 'select', required: true, helpText: 'Select the reporting boundary approach', options: ['Operational Control', 'Financial Control', 'Equity Share'] },
          { id: 'assumptions-estimations', name: 'Assumptions & Estimations', value: '', type: 'richtext', required: false, helpText: 'Any estimations or assumptions applied' },
          { id: 'exclusions', name: 'Exclusions', value: '', type: 'textarea', required: false, helpText: 'Any exclusions from the report' },
        ],
      },
      {
        id: 'directors-statement',
        name: '5. Responsible Directors\' Statement',
        completed: false,
        systemFields: [],
        editableFields: [
          { id: 'director-name', name: 'Director Name & Title', value: '', type: 'text', required: true, helpText: 'Name and title of approving director' },
          { id: 'approval-date', name: 'Approval Date', value: '', type: 'text', required: true, helpText: 'Date of approval' },
        ],
      },
      {
        id: 'appendix',
        name: '6. Appendix – Activity & Emission Details',
        completed: false,
        systemFields: [
          { id: 'gas-consumption-detail', name: 'Gas Consumption', value: 98420, unit: 'kWh', quality: dataQuality() },
          { id: 'fuel-use-detail', name: 'Fuel Use', value: 47200, unit: 'kWh', quality: dataQuality() },
          { id: 'electricity-detail', name: 'Electricity', value: 298450, unit: 'kWh', quality: dataQuality() },
          { id: 'travel-km', name: 'Business Travel KM', value: 459598, unit: 'km', quality: dataQuality('Estimated') },
        ],
        editableFields: [
          { id: 'travel-category-factors', name: 'Travel Category Factors', value: '', type: 'textarea', required: false, helpText: 'Details on travel category conversion factors used' },
        ],
      },
    ];
  }

  if (framework === 'CSRD') {
    return [
      {
        id: 'executive-summary',
        name: '1. Executive Summary',
        completed: false,
        systemFields: [
          { id: 'scope1-total', name: 'Scope 1 Total', value: 46.2, unit: 'tCO₂e', quality: dataQuality('Estimated') },
          { id: 'scope2-total', name: 'Scope 2 Total', value: 462, unit: 'tCO₂e', quality: dataQuality() },
          { id: 'scope3-total', name: 'Scope 3 Total', value: 280, unit: 'tCO₂e', quality: dataQuality() },
          { id: 'yoy-change', name: 'Total YoY % Change', value: -12.3, unit: '%', quality: dataQuality() },
          { id: 'top-sources', name: 'Top 5 Emission Sources', value: 'Electricity (58%), Natural Gas (18%), Business Travel (12%), Company Vehicles (8%), Waste (4%)', unit: '', quality: dataQuality() },
        ],
        editableFields: [
          { id: 'performance-overview', name: '1.1 Overview of Sustainability Performance', value: '', type: 'richtext', required: true, helpText: 'High-level summary of the year' },
          { id: 'challenges-risks', name: '1.3 Key Challenges & Risks', value: '', type: 'richtext', required: false, helpText: 'Narrative on challenges and opportunities' },
          { id: 'strategic-alignment', name: '1.4 Strategic Alignment', value: '', type: 'richtext', required: false, helpText: 'How sustainability aligns to business strategy' },
        ],
      },
      {
        id: 'basis-of-preparation',
        name: '2. Basis of Preparation',
        completed: false,
        systemFields: [
          { id: 'data-sources-summary', name: 'CarbonView Activity Data', value: 'Electricity, fuel, waste, travel and water activity records', unit: '', quality: dataQuality() },
          { id: 'supplier-data-overview', name: 'Supplier Uploaded Data', value: 'Supplier questionnaires and uploaded activity files', unit: '', quality: dataQuality('Estimated') },
        ],
        editableFields: [
          { id: 'entities-included', name: '2.1 Entities Included', value: '', type: 'richtext', required: true, helpText: 'List of entities included in the reporting boundary' },
          { id: 'consolidation-approach', name: '2.1 Consolidation Approach', value: '', type: 'textarea', required: false, helpText: 'Financial control, operational control, or equity share' },
          { id: 'operational-boundaries', name: '2.1 Operational Boundaries', value: '', type: 'textarea', required: false, helpText: 'Description of operational boundaries' },
          { id: 'additional-data', name: '2.2 Additional Data Not in CarbonView', value: '', type: 'textarea', required: false, helpText: 'Description of data sources outside CarbonView' },
          { id: 'restatements', name: '2.3 Restatements', value: '', type: 'richtext', required: false, helpText: 'Explanation of any restatements' },
        ],
      },
      {
        id: 'double-materiality',
        name: '3. Double Materiality Assessment (DMA)',
        completed: false,
        systemFields: [],
        editableFields: [
          { id: 'dma-methodology', name: '3.1 Methodology', value: '', type: 'richtext', required: true, helpText: 'Stakeholder engagement, workflow, assessment steps' },
          { id: 'material-topics', name: '3.2 Material Topics Identified', value: '', type: 'richtext', required: true, helpText: 'List of material environmental/social/governance topics' },
          { id: 'materiality-matrix', name: '3.3 Materiality Matrix', value: '', type: 'textarea', required: false, helpText: 'Upload DMA matrix visual or description' },
        ],
      },
      {
        id: 'business-model-strategy',
        name: '4. Business Model & Strategy',
        completed: false,
        systemFields: [],
        editableFields: [
          { id: 'company-profile', name: '4.1 Company Profile & Value Chain', value: '', type: 'richtext', required: true, helpText: 'Description of products, geographies, value chain' },
          { id: 'strategic-integration', name: '4.2 Strategic Integration', value: '', type: 'richtext', required: false, helpText: 'Climate strategy, transition plan narrative, sustainability commitments' },
        ],
      },
      {
        id: 'governance',
        name: '5. Governance',
        completed: false,
        systemFields: [],
        editableFields: [
          { id: 'governance-structure', name: '5.1 Sustainability Governance Structure', value: '', type: 'richtext', required: true, helpText: 'Board oversight, ESG committee roles' },
          { id: 'policies-controls', name: '5.2 Policies & Controls', value: '', type: 'richtext', required: false, helpText: 'Code of conduct, anti-corruption, ethics training' },
        ],
      },
      {
        id: 'e1-climate-change',
        name: '6.1 ESRS E1 - Climate Change',
        completed: false,
        systemFields: [
          { id: 'scope1-current', name: 'Scope 1 (Current Year)', value: 46.2, unit: 'tCO₂e', quality: dataQuality('Estimated') },
          { id: 'scope1-previous', name: 'Scope 1 (Previous Year)', value: 52.8, unit: 'tCO₂e', quality: dataQuality() },
          { id: 'scope2-current', name: 'Scope 2 Location (Current Year)', value: 462, unit: 'tCO₂e', quality: dataQuality() },
          { id: 'scope2-previous', name: 'Scope 2 Location (Previous Year)', value: 518, unit: 'tCO₂e', quality: dataQuality() },
          { id: 'scope3-current', name: 'Scope 3 (Current Year)', value: 280, unit: 'tCO₂e', quality: dataQuality() },
          { id: 'scope3-previous', name: 'Scope 3 (Previous Year)', value: 325, unit: 'tCO₂e', quality: dataQuality() },
          { id: 'intensity-current', name: 'Emission Intensity (Current)', value: 3.89, unit: 'tCO₂e/FTE', quality: dataQuality() },
          { id: 'intensity-previous', name: 'Emission Intensity (Previous)', value: 4.42, unit: 'tCO₂e/FTE', quality: dataQuality() },
        ],
        editableFields: [
          { id: 'transition-plan', name: '6.1.2 Transition Plan', value: '', type: 'richtext', required: true, helpText: 'Narrative on transition plan & climate scenario alignment' },
          { id: 'carbon-removals', name: '6.1.3 Carbon Removals & Offsets', value: '', type: 'richtext', required: false, helpText: 'Explanation of offsets used' },
        ],
      },
      {
        id: 'e2-pollution',
        name: '6.2 ESRS E2 - Pollution',
        completed: false,
        systemFields: [],
        editableFields: [
          { id: 'pollution-narrative', name: 'Pollution Sources, Controls & Compliance', value: '', type: 'richtext', required: false, helpText: 'Pollutant sources, controls, compliance' },
        ],
      },
      {
        id: 'e3-water',
        name: '6.3 ESRS E3 - Water & Marine Resources',
        completed: false,
        systemFields: [
          { id: 'water-withdrawn', name: 'Water Withdrawn', value: 12500, unit: 'm³', quality: dataQuality() },
          { id: 'water-discharged', name: 'Water Discharged', value: 11200, unit: 'm³', quality: dataQuality() },
          { id: 'water-recycled', name: 'Water Recycled', value: 18, unit: '%', quality: dataQuality('Estimated') },
        ],
        editableFields: [
          { id: 'water-risk', name: '6.3.2 Water Risk Narrative', value: '', type: 'richtext', required: false, helpText: 'Regions, stress factors, mitigation' },
        ],
      },
      {
        id: 'e4-biodiversity',
        name: '6.4 ESRS E4 - Biodiversity & Ecosystems',
        completed: false,
        systemFields: [],
        editableFields: [
          { id: 'biodiversity-assessment', name: 'Biodiversity Assessment', value: '', type: 'richtext', required: false, helpText: 'Biodiversity assessment, protected areas, actions' },
        ],
      },
      {
        id: 'e5-circular-economy',
        name: '6.5 ESRS E5 - Resource Use & Circular Economy',
        completed: false,
        systemFields: [
          { id: 'waste-total', name: 'Total Waste', value: 245, unit: 'tonnes', quality: dataQuality() },
          { id: 'waste-hazardous', name: 'Hazardous Waste', value: 12, unit: 'tonnes', quality: dataQuality() },
          { id: 'waste-recycling', name: 'Recycling Rate', value: 68, unit: '%', quality: dataQuality() },
        ],
        editableFields: [
          { id: 'circularity-initiatives', name: '6.5.2 Circularity Initiatives', value: '', type: 'richtext', required: false, helpText: 'Activities, reuse programs, design-for-circularity' },
        ],
      },
      {
        id: 'social-disclosures',
        name: '7. Social Disclosures (S1-S4)',
        completed: false,
        systemFields: [],
        editableFields: [
          { id: 's1-workforce', name: '7.1 S1 - Own Workforce', value: '', type: 'richtext', required: false, helpText: 'Workforce breakdown, safety metrics, wellbeing' },
          { id: 's2-value-chain', name: '7.2 S2 - Workers in Value Chain', value: '', type: 'richtext', required: false, helpText: 'Supplier audits, third-party labour practices' },
          { id: 's3-communities', name: '7.3 S3 - Affected Communities', value: '', type: 'richtext', required: false, helpText: 'Community programs, impact assessments' },
          { id: 's4-consumers', name: '7.4 S4 - Consumers & End-Users', value: '', type: 'richtext', required: false, helpText: 'Product safety, data protection' },
        ],
      },
      {
        id: 'governance-conduct',
        name: '8. Governance (G1 - Business Conduct)',
        completed: false,
        systemFields: [],
        editableFields: [
          { id: 'business-conduct', name: 'Business Conduct', value: '', type: 'richtext', required: false, helpText: 'Anti-corruption, whistleblowing, compliance management' },
        ],
      },
      {
        id: 'eu-taxonomy',
        name: '9. EU Taxonomy Disclosures',
        completed: false,
        systemFields: [
          { id: 'taxonomy-kpi-data', name: 'Taxonomy KPI Data', value: 'Emissions: 788.2 tCO₂e, Energy: 496,250 kWh, Water: 12,500 m³', unit: '', quality: dataQuality() },
        ],
        editableFields: [
          { id: 'eligibility-assessment', name: '9.1 Eligibility Assessment', value: '', type: 'richtext', required: false, helpText: 'Activity classification & mapping' },
          { id: 'alignment-assessment', name: '9.2 Alignment Assessment', value: '', type: 'richtext', required: false, helpText: 'DNSH, Minimum Safeguards narrative' },
        ],
      },
      {
        id: 'targets-performance',
        name: '10. Targets & Performance Tracking',
        completed: false,
        systemFields: [
          { id: 'emissions-trend', name: 'Emissions Trend', value: 'Year 1: 896 tCO₂e, Year 2: 788 tCO₂e, Year 3: 788 tCO₂e', unit: '', quality: dataQuality() },
          { id: 'water-trend', name: 'Water Trend', value: 'Year 1: 14,200 m³, Year 2: 13,100 m³, Year 3: 12,500 m³', unit: '', quality: dataQuality() },
          { id: 'waste-trend', name: 'Waste Trend', value: 'Year 1: 285 tonnes, Year 2: 265 tonnes, Year 3: 245 tonnes', unit: '', quality: dataQuality() },
        ],
        editableFields: [
          { id: 'performance-narrative', name: '10.2 Narrative on Progress', value: '', type: 'richtext', required: false, helpText: 'Explanation of performance against targets' },
        ],
      },
      {
        id: 'assurance-statement',
        name: '11. Assurance Statement',
        completed: false,
        systemFields: [],
        editableFields: [
          { id: 'assurance-text', name: 'Assurance Statement', value: '', type: 'richtext', required: false, helpText: 'Assurance provider text, scope, conclusions' },
        ],
      },
      {
        id: 'esrs-content-index',
        name: '12. ESRS Content Index',
        completed: false,
        systemFields: [],
        editableFields: [
          { id: 'esrs-index', name: 'ESRS Index Table', value: '', type: 'richtext', required: false, helpText: 'ESRS content index table' },
          { id: 'missing-disclosures', name: 'Missing Disclosures Rationale', value: '', type: 'textarea', required: false, helpText: 'Explanation for any missing disclosures' },
        ],
      },
      {
        id: 'appendices',
        name: '13. Appendices',
        completed: false,
        systemFields: [
          { id: 'carbonview-data-tables', name: 'CarbonView Data Tables', value: 'Raw data tables exported from CarbonView system', unit: '', quality: dataQuality() },
        ],
        editableFields: [
          { id: 'methodology-notes', name: 'Methodology Notes', value: '', type: 'richtext', required: false, helpText: 'Detailed methodology notes' },
          { id: 'glossary', name: 'Glossary', value: '', type: 'richtext', required: false, helpText: 'Terms and definitions' },
        ],
      },
    ];
  }

  return [
    {
      id: 'governance',
      name: '1. Governance',
      completed: false,
      systemFields: [
        { id: 'board-reviews', name: 'Board Review Frequency', value: 'Quarterly', unit: '', quality: dataQuality() },
      ],
      editableFields: [
        { id: 'board-oversight', name: 'Board Oversight', value: '', type: 'textarea', required: true, helpText: 'Describe board-level oversight of climate risks and opportunities.' },
        { id: 'management-role', name: 'Management Role', value: '', type: 'textarea', required: true },
      ],
    },
    {
      id: 'strategy',
      name: '2. Strategy',
      completed: false,
      systemFields: [
        { id: 'total-emissions', name: 'Total Carbon Emissions', value: 788.2, unit: 'tCO2e', quality: dataQuality() },
        { id: 'reduction', name: 'Year-on-Year Change', value: -12.3, unit: '%', quality: dataQuality() },
      ],
      editableFields: [
        { id: 'risks-opportunities', name: 'Climate Risks and Opportunities', value: '', type: 'textarea', required: true },
        { id: 'scenario-analysis', name: 'Scenario Analysis', value: '', type: 'textarea', required: false },
      ],
    },
    {
      id: 'metrics-targets',
      name: '3. Metrics and Targets',
      completed: false,
      systemFields: [
        { id: 'scope1', name: 'Scope 1', value: 267.8, unit: 'tCO2e', quality: dataQuality() },
        { id: 'scope2', name: 'Scope 2', value: 401.2, unit: 'tCO2e', quality: dataQuality() },
        { id: 'scope3', name: 'Scope 3', value: 119.2, unit: 'tCO2e', quality: dataQuality('Estimated') },
      ],
      editableFields: [
        { id: 'targets', name: 'Targets', value: '', type: 'textarea', required: true },
        { id: 'transition-plan', name: 'Transition Plan', value: '', type: 'textarea', required: false },
      ],
    },
  ];
};

export const findFieldValue = (sections, fieldId, fallback = '') => {
  for (const section of sections) {
    const editableField = section.editableFields.find((field) => field.id === fieldId);
    if (editableField && editableField.value) return editableField.value;
    const systemField = section.systemFields.find((field) => field.id === fieldId);
    if (systemField && systemField.value !== null && systemField.value !== undefined) {
      return `${systemField.value}${systemField.unit ? ` ${systemField.unit}` : ''}`;
    }
  }
  return fallback;
};

const token = (value, field, quality = 'Actual') => (
  `<span class="narrative-data-token" title="Hover to see data source" data-field="${field}" data-quality="${quality}">{${value}}</span>`
);

export const generateNarrative = (sections, framework, reportName, reportingPeriod) => {
  if (framework === 'SECR') {
    return `
      <h1>${reportName || 'SECR REPORT'}</h1>
      <h2 style="color: #0B64B3;">Streamlined Energy and Carbon Reporting</h2>
      <p><strong>Reporting Year:</strong> ${reportingPeriod || '[USER INPUT → Start Date – End Date]'}</p>

      <h3>1. Executive Summary</h3>
      <p>This SECR statement summarises the organisation's energy use, associated greenhouse gas emissions, and energy-efficiency actions for the reporting year.</p>
      <p><strong>Total Carbon Emissions (tCO₂e):</strong> ${token(findFieldValue(sections, 'total-emissions'), 'total-emissions')}</p>
      <p><strong>Year-on-Year Change:</strong> ${token(findFieldValue(sections, 'yoy-change'), 'yoy-change')}</p>
      <p><strong>Operational Intensity Ratio:</strong> ${token(findFieldValue(sections, 'intensity-ratio-value'), 'intensity-ratio')}</p>
      <p><strong>Organisation boundary:</strong> ${findFieldValue(sections, 'org-boundary', '[USER INPUT → e.g., UK operations only / Global legal entities]')}</p>

      <h3>2. Annual Reporting Figures</h3>
      <h4>2.1 Total Energy Consumption (kWh)</h4>
      <table border="1" style="width: 100%; border-collapse: collapse; margin: 16px 0;">
        <thead>
          <tr style="background-color: #f3f3f5;">
            <th style="padding: 12px; text-align: left;">Source</th>
            <th style="padding: 12px; text-align: right;">Energy Consumption</th>
            <th style="padding: 12px; text-align: left;">Source System</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="padding: 12px;">Scope 1 – Gas &amp; Fuels</td>
            <td style="padding: 12px; text-align: right;">${token('145,620 kWh', 'scope1-gas-fuels')}</td>
            <td style="padding: 12px;">CarbonView</td>
          </tr>
          <tr style="background-color: #fafafa;">
            <td style="padding: 12px;">Scope 2 – Electricity</td>
            <td style="padding: 12px; text-align: right;">${token('298,450 kWh', 'scope2-electricity')}</td>
            <td style="padding: 12px;">CarbonView</td>
          </tr>
          <tr>
            <td style="padding: 12px;">Scope 3 – Business Travel (kWh equivalent)</td>
            <td style="padding: 12px; text-align: right;">${token('52,180 kWh', 'scope3-travel', 'Estimated')}</td>
            <td style="padding: 12px;">CarbonView</td>
          </tr>
          <tr style="background-color: #f3f3f5; font-weight: bold;">
            <td style="padding: 12px;">Total Energy Consumption</td>
            <td style="padding: 12px; text-align: right;">${token('496,250 kWh', 'total-energy')}</td>
            <td style="padding: 12px;">CarbonView</td>
          </tr>
        </tbody>
      </table>

      <h4>2.2 Greenhouse Gas (GHG) Emissions (tCO₂e)</h4>
      <table border="1" style="width: 100%; border-collapse: collapse; margin: 16px 0;">
        <thead>
          <tr style="background-color: #f3f3f5;">
            <th style="padding: 12px; text-align: left;">Scope</th>
            <th style="padding: 12px; text-align: right;">Emissions</th>
            <th style="padding: 12px; text-align: left;">Source</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="padding: 12px;">Scope 1</td>
            <td style="padding: 12px; text-align: right;">${token('267.8 tCO₂e', 'scope1-emissions')}</td>
            <td style="padding: 12px;">CarbonView</td>
          </tr>
          <tr style="background-color: #fafafa;">
            <td style="padding: 12px;">Scope 2</td>
            <td style="padding: 12px; text-align: right;">${token('401.2 tCO₂e', 'scope2-emissions')}</td>
            <td style="padding: 12px;">CarbonView</td>
          </tr>
          <tr>
            <td style="padding: 12px;">Scope 3</td>
            <td style="padding: 12px; text-align: right;">${token('119.2 tCO₂e', 'scope3-emissions', 'Estimated')}</td>
            <td style="padding: 12px;">CarbonView</td>
          </tr>
          <tr style="background-color: #f3f3f5; font-weight: bold;">
            <td style="padding: 12px;">Total Emissions</td>
            <td style="padding: 12px; text-align: right;">${token('788.2 tCO₂e', 'total-emissions-section2')}</td>
            <td style="padding: 12px;">CarbonView</td>
          </tr>
        </tbody>
      </table>
      <p><strong>Notes/Exclusions:</strong> ${findFieldValue(sections, 'notes-exclusions', '[USER INPUT → e.g., Refrigerants not included due to data limits]')}</p>

      <h4>2.3 SECR Intensity Metrics</h4>
      <p><strong>Selected intensity ratio:</strong> ${findFieldValue(sections, 'intensity-metric-selected', '[USER INPUT → e.g., tCO₂e per FTE / per £m turnover / per m² floor area]')}</p>
      <p><strong>Intensity value:</strong> ${token('3.89 tCO₂e/FTE', 'intensity-calculated')}</p>
      <p><strong>YOY change:</strong> ${token('-8.5 %', 'intensity-yoy')}</p>

      <h3>3. Energy Efficiency Actions</h3>
      <h4>Energy Efficiency Measures Implemented</h4>
      <p>${findFieldValue(sections, 'measures-implemented', '[USER INPUT → Measures implemented in reporting year]')}</p>
      <p>${findFieldValue(sections, 'quantifiable-savings', '[USER INPUT → Any quantifiable savings]')}</p>
      <h4>Planned Initiatives</h4>
      <p>${findFieldValue(sections, 'planned-initiatives', '[USER INPUT → Planned measures for next year]')}</p>
      <p>(CarbonView can track savings and reductions where projects are added.)</p>

      <h3>4. Methodology</h3>
      <h4>4.1 Standards Used</h4>
      <ul>
        <li>Environmental Reporting Guidelines (March 2019)</li>
        <li>GHG Protocol Corporate Standard</li>
        <li>DEFRA UK Government Conversion Factors (Excel)</li>
      </ul>
      <p><strong>Calculations performed through CarbonView:</strong></p>
      <p>${token('DEFRA UK Government Conversion Factors 2023', 'conversion-factors')}</p>
      <p>${token('Emission factor source: DEFRA 2023', 'emission-factor-source')}</p>
      <h4>4.2 Reporting Boundary</h4>
      <p>${findFieldValue(sections, 'reporting-boundary-method', '[USER INPUT → Operational control / financial control / equity share]')}</p>
      <h4>4.3 Assumptions &amp; Estimations</h4>
      <p>${findFieldValue(sections, 'assumptions-estimations', '[USER INPUT → Any estimations applied]')}</p>
      <p>${findFieldValue(sections, 'exclusions', '[USER INPUT → Any exclusions]')}</p>

      <h3>5. Responsible Directors' Statement</h3>
      <p>This SECR report has been approved by:</p>
      <p>${findFieldValue(sections, 'director-name', '[USER INPUT → Director Name &amp; Title]')}</p>
      <p><strong>Date:</strong> ${findFieldValue(sections, 'approval-date', '[USER INPUT → Approval date]')}</p>

      <h3>6. Appendix – Activity &amp; Emission Details</h3>
      <h4>6.1 Scope 1 Detailed Activity</h4>
      <p><strong>Gas consumption (kWh):</strong> ${token('98,420 kWh', 'gas-consumption-detail')}</p>
      <p><em style="color: #666; font-size: 0.9em;">Source: Activity Type = Fuel Combustion (LNG, Natural Gas (General), Natural Gas (HVAC), Propane, Other Combustible Gases) with unit = kWh</em></p>
      <p><strong>Fuel use:</strong> ${token('47,200 kWh', 'fuel-use-detail')}</p>
      <p><em style="color: #666; font-size: 0.9em;">Source: Activity Type = Fuel Combustion (Diesel, LNG, Biodiesel, Gasoline, Natural Gas (General), Propane) with unit = kWh</em></p>
      <h4>6.2 Scope 2 Electricity</h4>
      <p><strong>Electricity (kWh):</strong> ${token('298,450 kWh', 'electricity-detail')}</p>
      <p><em style="color: #666; font-size: 0.9em;">Source: Activity Type = Electricity Use with unit = kWh</em></p>
      <h4>6.3 Scope 3 Travel</h4>
      <p><strong>Business travel (km):</strong> ${token('459,598 km', 'travel-km', 'Estimated')}</p>
      <p><em style="color: #666; font-size: 0.9em;">Source: Activity Type = Transport (Petrol Car/Van, Diesel Car/Van, Electric Car/Van, Hybrid Car/Van, Motorcycle) with unit = km</em></p>
      <p><strong>Category conversion factors:</strong> ${findFieldValue(sections, 'travel-category-factors', '[USER INPUT → Travel category factors]')}</p>
    `;
  }

  if (framework === 'CSRD') {
    return `
      <h1>${reportName || '[CARBONVIEW INPUT → Organisation Name]'}</h1>
      <h2 style="color: #0B64B3;">CSRD Sustainability Statement</h2>
      <p style="font-style: italic;">(CarbonView Auto-Generated — ESRS-Aligned)</p>
      <p><strong>Reporting Year:</strong> ${reportingPeriod || '[USER INPUT → Start Date – End Date]'}</p>

      <h3>Table of Contents</h3>
      <p>[Auto-generated based on the below contents]</p>

      <h3>1. Executive Summary</h3>
      <h4>1.1 Overview of Sustainability Performance</h4>
      <p>${findFieldValue(sections, 'performance-overview', '[USER INPUT → High-level summary of the year]')}</p>
      <h4>1.2 Emissions Summary</h4>
      <p><strong>Scope 1 total:</strong> ${token('46.2 tCO₂e', 'scope1-total', 'Estimated')}</p>
      <p><strong>Scope 2 total:</strong> ${token('462 tCO₂e', 'scope2-total')}</p>
      <p><strong>Scope 3 total:</strong> ${token('280 tCO₂e', 'scope3-total')}</p>
      <p><strong>Total YoY % change:</strong> ${token('-12.3 %', 'yoy-change')}</p>
      <p><strong>Top emission sources:</strong> ${token('Electricity (58%), Natural Gas (18%), Business Travel (12%), Company Vehicles (8%), Waste (4%)', 'top-sources')}</p>
      <p><em style="color: #666; font-size: 0.9em;">% = (tCO₂e of each EPS / Total tCO₂e) × 100</em></p>
      <h4>1.3 Key Challenges &amp; Risks</h4>
      <p>${findFieldValue(sections, 'challenges-risks', '[USER INPUT → Narrative on challenges and opportunities]')}</p>
      <h4>1.4 Strategic Alignment</h4>
      <p>${findFieldValue(sections, 'strategic-alignment', '[USER INPUT → How sustainability aligns to business strategy]')}</p>

      <h3>2. Basis of Preparation</h3>
      <h4>2.1 Reporting Boundaries</h4>
      <p>${findFieldValue(sections, 'entities-included', '[USER INPUT → Entities Included]')}</p>
      <p>${findFieldValue(sections, 'consolidation-approach', '[USER INPUT → Consolidation Approach]')}</p>
      <p>${findFieldValue(sections, 'operational-boundaries', '[USER INPUT → Operational Boundaries]')}</p>
      <h4>2.2 Data Sources</h4>
      <p><strong>Additional data not in CarbonView:</strong> ${findFieldValue(sections, 'additional-data', '[USER INPUT → description]')}</p>
      <h4>2.3 Restatements</h4>
      <p>${findFieldValue(sections, 'restatements', '[USER INPUT → Explanation of restatements]')}</p>

      <h3>3. Double Materiality Assessment (DMA)</h3>
      <h4>3.1 Methodology</h4>
      <p>${findFieldValue(sections, 'dma-methodology', '[USER INPUT → stakeholder engagement, workflow, assessment steps]')}</p>
      <h4>3.2 Material Topics Identified</h4>
      <p>${findFieldValue(sections, 'material-topics', '[USER INPUT → List of material environmental/social/governance topics]')}</p>
      <h4>3.3 Materiality Matrix</h4>
      <p>${findFieldValue(sections, 'materiality-matrix', '[USER INPUT → Upload DMA matrix visual]')}</p>

      <h3>4. Business Model &amp; Strategy</h3>
      <h4>4.1 Company Profile &amp; Value Chain</h4>
      <p>${findFieldValue(sections, 'company-profile', '[USER INPUT → description of products, geographies, value chain]')}</p>
      <h4>4.2 Strategic Integration</h4>
      <p>${findFieldValue(sections, 'strategic-integration', '[USER INPUT → climate strategy, transition plan narrative, sustainability commitments]')}</p>

      <h3>5. Governance</h3>
      <h4>5.1 Sustainability Governance Structure</h4>
      <p>${findFieldValue(sections, 'governance-structure', '[USER INPUT → board oversight, ESG committee roles]')}</p>
      <h4>5.2 Policies &amp; Controls</h4>
      <p>${findFieldValue(sections, 'policies-controls', '[USER INPUT → Code of conduct, anti-corruption, ethics training]')}</p>

      <h3>6. Environmental Disclosures (E1–E5)</h3>

      <h4>6.1 ESRS E1 – Climate Change</h4>
      <h5>6.1.1 GHG Inventory Summary</h5>
      <table border="1" style="width: 100%; border-collapse: collapse; margin: 16px 0;">
        <thead>
          <tr style="background-color: #f3f3f5;">
            <th style="padding: 12px; text-align: left;">KPI</th>
            <th style="padding: 12px; text-align: left;">Unit</th>
            <th style="padding: 12px; text-align: right;">Current Year</th>
            <th style="padding: 12px; text-align: right;">Previous Year</th>
            <th style="padding: 12px; text-align: center;">Trend</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="padding: 12px;">Scope 1</td>
            <td style="padding: 12px;">tCO₂e</td>
            <td style="padding: 12px; text-align: right;">${token('46.2', 'scope1-current', 'Estimated')}</td>
            <td style="padding: 12px; text-align: right;">${token('52.8', 'scope1-previous')}</td>
            <td style="padding: 12px; text-align: center;">↓</td>
          </tr>
          <tr style="background-color: #fafafa;">
            <td style="padding: 12px;">Scope 2 (location)</td>
            <td style="padding: 12px;">tCO₂e</td>
            <td style="padding: 12px; text-align: right;">${token('462', 'scope2-current')}</td>
            <td style="padding: 12px; text-align: right;">${token('518', 'scope2-previous')}</td>
            <td style="padding: 12px; text-align: center;">↓</td>
          </tr>
          <tr>
            <td style="padding: 12px;">Scope 3</td>
            <td style="padding: 12px;">tCO₂e</td>
            <td style="padding: 12px; text-align: right;">${token('280', 'scope3-current')}</td>
            <td style="padding: 12px; text-align: right;">${token('325', 'scope3-previous')}</td>
            <td style="padding: 12px; text-align: center;">↓</td>
          </tr>
          <tr style="background-color: #fafafa;">
            <td style="padding: 12px;">Emission intensity</td>
            <td style="padding: 12px;">tCO₂e/No. of employee</td>
            <td style="padding: 12px; text-align: right;">${token('3.89', 'intensity-current')}</td>
            <td style="padding: 12px; text-align: right;">${token('4.42', 'intensity-previous')}</td>
            <td style="padding: 12px; text-align: center;">↓</td>
          </tr>
        </tbody>
      </table>
      <h5>6.1.2 Transition Plan</h5>
      <p>${findFieldValue(sections, 'transition-plan', '[USER INPUT → narrative on transition plan &amp; climate scenario alignment]')}</p>
      <h5>6.1.3 Carbon Removals &amp; Offsets</h5>
      <p>${findFieldValue(sections, 'carbon-removals', '[USER INPUT → explanation of offsets used]')}</p>

      <h4>6.2 ESRS E2 – Pollution</h4>
      <p>${findFieldValue(sections, 'pollution-narrative', '[USER INPUT → pollutant sources, controls, compliance]')}</p>

      <h4>6.3 ESRS E3 – Water &amp; Marine Resources</h4>
      <h5>6.3.1 Water Metrics</h5>
      <p><strong>Water withdrawn:</strong> ${token('12,500 m³', 'water-withdrawn')}
        <br/><em style="color: #666; font-size: 0.9em;">Source: Activity Type = Water Use – Water Withdrawal</em>
      </p>
      <p><strong>Water discharged:</strong> ${token('11,200 m³', 'water-discharged')}
        <br/><em style="color: #666; font-size: 0.9em;">Source: Activity Type = Water Use – Water Discharged</em>
      </p>
      <p><strong>Water recycled:</strong> ${token('18 %', 'water-recycled', 'Estimated')}
        <br/><em style="color: #666; font-size: 0.9em;">Source: Activity Type = Water Use – Water Recycled</em>
      </p>
      <h5>6.3.2 Water Risk Narrative</h5>
      <p>${findFieldValue(sections, 'water-risk', '[USER INPUT → regions, stress factors, mitigation]')}</p>

      <h4>6.4 ESRS E4 – Biodiversity &amp; Ecosystems</h4>
      <p>${findFieldValue(sections, 'biodiversity-assessment', '[USER INPUT → biodiversity assessment, protected areas, actions]')}</p>

      <h4>6.5 ESRS E5 – Resource Use &amp; Circular Economy</h4>
      <h5>6.5.1 Waste Metrics</h5>
      <p><strong>Total waste:</strong> ${token('245 tonnes', 'waste-total')}
        <br/><em style="color: #666; font-size: 0.9em;">Source: Activity Type = Waste</em>
      </p>
      <p><strong>Hazardous waste:</strong> ${token('12 tonnes', 'waste-hazardous')}
        <br/><em style="color: #666; font-size: 0.9em;">Source: Activity Type = Waste – Hazardous Waste</em>
      </p>
      <p><strong>Recycling rate:</strong> ${token('68 %', 'waste-recycling')}
        <br/><em style="color: #666; font-size: 0.9em;">Source: Activity Type = Waste – Recycled Waste</em>
      </p>
      <h5>6.5.2 Circularity Initiatives</h5>
      <p>${findFieldValue(sections, 'circularity-initiatives', '[USER INPUT → activities, reuse programs, design-for-circularity]')}</p>

      <h3>7. Social Disclosures (S1–S4)</h3>
      <h4>7.1 S1 – Own Workforce</h4>
      <p>${findFieldValue(sections, 's1-workforce', '[USER INPUT → workforce breakdown, safety metrics, wellbeing]')}</p>
      <h4>7.2 S2 – Workers in Value Chain</h4>
      <p>${findFieldValue(sections, 's2-value-chain', '[USER INPUT → supplier audits, third-party labour practices]')}</p>
      <h4>7.3 S3 – Affected Communities</h4>
      <p>${findFieldValue(sections, 's3-communities', '[USER INPUT → community programs, impact assessments]')}</p>
      <h4>7.4 S4 – Consumers &amp; End-Users</h4>
      <p>${findFieldValue(sections, 's4-consumers', '[USER INPUT → product safety, data protection]')}</p>

      <h3>8. Governance (G1 – Business Conduct)</h3>
      <p>${findFieldValue(sections, 'business-conduct', '[USER INPUT → anti-corruption, whistleblowing, compliance management]')}</p>

      <h3>9. EU Taxonomy Disclosures</h3>
      <h4>9.1 Eligibility Assessment</h4>
      <p>${findFieldValue(sections, 'eligibility-assessment', '[USER INPUT → activity classification &amp; mapping]')}</p>
      <h4>9.2 Alignment Assessment</h4>
      <p>${findFieldValue(sections, 'alignment-assessment', '[USER INPUT → DNSH, Minimum Safeguards narrative]')}</p>
      <p><strong>Numeric values used in calculations:</strong></p>
      <p>${token('Emissions: 788.2 tCO₂e, Energy: 496,250 kWh, Water: 12,500 m³', 'taxonomy-kpi-data')}</p>
      <p><em style="color: #666; font-size: 0.9em;">
        Emissions: Total tCO₂e of the organisation<br/>
        Energy: Electricity Consumption (Activity Type = Electricity Use) + Fuel Combustion (Activity Type = Fuel Combustion) in kWh<br/>
        Water: Water Consumption (Activity Type = Water Use) in m³
      </em></p>

      <h3>10. Targets &amp; Performance Tracking</h3>
      <h4>10.1 KPI Overview</h4>
      <p><strong>Emissions trend (last 3 years):</strong> ${token('Year 1: 896 tCO₂e, Year 2: 788 tCO₂e, Year 3: 788 tCO₂e', 'emissions-trend')}
        <br/><em style="color: #666; font-size: 0.9em;">Source: Total tCO₂e of the organisation for the last 3 years up to the selected year</em>
      </p>
      <p><strong>Water trend (last 3 years):</strong> ${token('Year 1: 14,200 m³, Year 2: 13,100 m³, Year 3: 12,500 m³', 'water-trend')}
        <br/><em style="color: #666; font-size: 0.9em;">Source: Activity Type = Water Use for the last 3 years up to the selected year</em>
      </p>
      <p><strong>Waste trend (last 3 years):</strong> ${token('Year 1: 285 tonnes, Year 2: 265 tonnes, Year 3: 245 tonnes', 'waste-trend')}
        <br/><em style="color: #666; font-size: 0.9em;">Source: Activity Type = Waste for the last 3 years up to the selected year</em>
      </p>
      <h4>10.2 Narrative on Progress</h4>
      <p>${findFieldValue(sections, 'performance-narrative', '[USER INPUT → explanation of performance against targets]')}</p>

      <h3>11. Assurance Statement</h3>
      <p>${findFieldValue(sections, 'assurance-text', '[USER INPUT → assurance provider text, scope, conclusions]')}</p>

      <h3>12. ESRS Content Index</h3>
      <p>${findFieldValue(sections, 'esrs-index', '[USER INPUT → ESRS index table]')}</p>
      <p><strong>Missing disclosures rationale:</strong></p>
      <p>${findFieldValue(sections, 'missing-disclosures', '[USER INPUT → explanation]')}</p>

      <h3>13. Appendices</h3>
      <p><strong>CarbonView data tables:</strong> ${token('Raw data tables exported from CarbonView system', 'carbonview-data-tables')}</p>

      <h4>ESRS E1 – Climate</h4>
      <table border="1" style="width: 100%; border-collapse: collapse; margin: 16px 0; font-size: 0.9em;">
        <thead>
          <tr style="background-color: #f3f3f5;">
            <th style="padding: 8px;">Scope</th>
            <th style="padding: 8px;">Entity</th>
            <th style="padding: 8px;">Activity Category</th>
            <th style="padding: 8px; text-align: right;">Contribution</th>
            <th style="padding: 8px;">Unit</th>
            <th style="padding: 8px;">Emission Factor</th>
            <th style="padding: 8px;">Source</th>
            <th style="padding: 8px; text-align: right;">CO₂e (t)</th>
            <th style="padding: 8px;">Periods</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="padding: 8px;">1</td><td style="padding: 8px;">[Entity Name]</td><td style="padding: 8px;">[Individual EPS assigned to the Entity]</td><td style="padding: 8px; text-align: right;">12,000</td><td style="padding: 8px;">L</td><td style="padding: 8px;">2.68 tCO₂e/L</td><td style="padding: 8px;">[Description of the EPS]</td><td style="padding: 8px; text-align: right;">32,160</td><td style="padding: 8px;">[Periods]</td>
          </tr>
          <tr style="background-color: #fafafa;">
            <td style="padding: 8px;">1</td><td style="padding: 8px;">[Entity Name]</td><td style="padding: 8px;">[Individual EPS assigned to the Entity]</td><td style="padding: 8px; text-align: right;">45,000</td><td style="padding: 8px;">kWh</td><td style="padding: 8px;">0.233 tCO₂e/kWh</td><td style="padding: 8px;">[Description of the EPS]</td><td style="padding: 8px; text-align: right;">10,485</td><td style="padding: 8px;">[Periods]</td>
          </tr>
          <tr>
            <td style="padding: 8px;">2</td><td style="padding: 8px;">[Entity Name]</td><td style="padding: 8px;">[Individual EPS assigned to the Entity]</td><td style="padding: 8px; text-align: right;">85,000</td><td style="padding: 8px;">kWh</td><td style="padding: 8px;">0.233 tCO₂e/kWh</td><td style="padding: 8px;">[Description of the EPS]</td><td style="padding: 8px; text-align: right;">19,805</td><td style="padding: 8px;">[Periods]</td>
          </tr>
          <tr style="background-color: #fafafa;">
            <td style="padding: 8px;">2</td><td style="padding: 8px;">[Entity Name]</td><td style="padding: 8px;">[Individual EPS assigned to the Entity]</td><td style="padding: 8px; text-align: right;">92,087</td><td style="padding: 8px;">km</td><td style="padding: 8px;">0.15 tCO₂e/km</td><td style="padding: 8px;">[Description of the EPS]</td><td style="padding: 8px; text-align: right;">13,813</td><td style="padding: 8px;">[Periods]</td>
          </tr>
          <tr>
            <td style="padding: 8px;">3</td><td style="padding: 8px;">[Entity Name]</td><td style="padding: 8px;">[Individual EPS assigned to the Entity]</td><td style="padding: 8px; text-align: right;">54,000</td><td style="padding: 8px;">km</td><td style="padding: 8px;">0.15 tCO₂e/km</td><td style="padding: 8px;">[Description of the EPS]</td><td style="padding: 8px; text-align: right;">8,100</td><td style="padding: 8px;">[Periods]</td>
          </tr>
          <tr style="background-color: #fafafa;">
            <td style="padding: 8px;">3</td><td style="padding: 8px;">[Entity Name]</td><td style="padding: 8px;">[Individual EPS assigned to the Entity]</td><td style="padding: 8px; text-align: right;">420</td><td style="padding: 8px;">m³</td><td style="padding: 8px;">1.85 tCO₂e/ton</td><td style="padding: 8px;">[Description of the EPS]</td><td style="padding: 8px; text-align: right;">777</td><td style="padding: 8px;">[Periods]</td>
          </tr>
        </tbody>
      </table>

      <h4>ESRS E2 – Pollution</h4>
      <table border="1" style="width: 100%; border-collapse: collapse; margin: 16px 0; font-size: 0.9em;">
        <thead>
          <tr style="background-color: #f3f3f5;">
            <th style="padding: 8px;">Entity</th>
            <th style="padding: 8px;">Fuel</th>
            <th style="padding: 8px; text-align: right;">Amount Combusted</th>
            <th style="padding: 8px;">Units</th>
            <th style="padding: 8px;">Valid From</th>
            <th style="padding: 8px;">Valid To</th>
          </tr>
        </thead>
        <tbody>
          <tr><td style="padding: 8px;">[Entity Name]</td><td style="padding: 8px;">[Fuel Type – Activity Type = Fuel]</td><td style="padding: 8px; text-align: right;">[Contribution]</td><td style="padding: 8px;">kWh</td><td style="padding: 8px;">[Period Start]</td><td style="padding: 8px;">[Period End]</td></tr>
          <tr style="background-color: #fafafa;"><td style="padding: 8px;">[Entity Name]</td><td style="padding: 8px;">[Fuel Type – Activity Type = Fuel]</td><td style="padding: 8px; text-align: right;">[Contribution]</td><td style="padding: 8px;">kL</td><td style="padding: 8px;">[Period Start]</td><td style="padding: 8px;">[Period End]</td></tr>
          <tr><td style="padding: 8px;">[Entity Name]</td><td style="padding: 8px;">[Fuel Type – Activity Type = Fuel]</td><td style="padding: 8px; text-align: right;">[Contribution]</td><td style="padding: 8px;">m³</td><td style="padding: 8px;">[Period Start]</td><td style="padding: 8px;">[Period End]</td></tr>
          <tr style="background-color: #fafafa;"><td style="padding: 8px;">[Entity Name]</td><td style="padding: 8px;">[Fuel Type – Activity Type = Fuel]</td><td style="padding: 8px; text-align: right;">[Contribution]</td><td style="padding: 8px;">GJ</td><td style="padding: 8px;">[Period Start]</td><td style="padding: 8px;">[Period End]</td></tr>
        </tbody>
      </table>

      <h4>ESRS E3 – Water</h4>
      <table border="1" style="width: 100%; border-collapse: collapse; margin: 16px 0; font-size: 0.9em;">
        <thead>
          <tr style="background-color: #f3f3f5;">
            <th style="padding: 8px;">Entity</th>
            <th style="padding: 8px;">Water</th>
            <th style="padding: 8px; text-align: right;">Volume</th>
            <th style="padding: 8px;">Unit</th>
            <th style="padding: 8px;">Valid From</th>
            <th style="padding: 8px;">Valid To</th>
          </tr>
        </thead>
        <tbody>
          <tr><td style="padding: 8px;">[Entity Name]</td><td style="padding: 8px;">[Water Type – Activity Type = Water]</td><td style="padding: 8px; text-align: right;">[Contribution]</td><td style="padding: 8px;">m³</td><td style="padding: 8px;">[Period Start]</td><td style="padding: 8px;">[Period End]</td></tr>
          <tr style="background-color: #fafafa;"><td style="padding: 8px;">[Entity Name]</td><td style="padding: 8px;">[Water Type – Activity Type = Water]</td><td style="padding: 8px; text-align: right;">[Contribution]</td><td style="padding: 8px;">L</td><td style="padding: 8px;">[Period Start]</td><td style="padding: 8px;">[Period End]</td></tr>
          <tr><td style="padding: 8px;">[Entity Name]</td><td style="padding: 8px;">[Water Type – Activity Type = Water]</td><td style="padding: 8px; text-align: right;">[Contribution]</td><td style="padding: 8px;">m³</td><td style="padding: 8px;">[Period Start]</td><td style="padding: 8px;">[Period End]</td></tr>
          <tr style="background-color: #fafafa;"><td style="padding: 8px;">[Entity Name]</td><td style="padding: 8px;">[Water Type – Activity Type = Water]</td><td style="padding: 8px; text-align: right;">[Contribution]</td><td style="padding: 8px;">m³</td><td style="padding: 8px;">[Period Start]</td><td style="padding: 8px;">[Period End]</td></tr>
        </tbody>
      </table>

      <h4>ESRS E4 – Biodiversity</h4>
      <p>${findFieldValue(sections, 'biodiversity-assessment', '[USER INPUT → biodiversity assessment, protected areas, actions]')}</p>

      <h4>ESRS E5 – Resource Use &amp; Circular Economy</h4>
      <table border="1" style="width: 100%; border-collapse: collapse; margin: 16px 0; font-size: 0.9em;">
        <thead>
          <tr style="background-color: #f3f3f5;">
            <th style="padding: 8px;">Entity</th>
            <th style="padding: 8px;">Waste Type</th>
            <th style="padding: 8px; text-align: right;">Contribution</th>
            <th style="padding: 8px;">Unit</th>
            <th style="padding: 8px;">Valid From</th>
            <th style="padding: 8px;">Valid To</th>
          </tr>
        </thead>
        <tbody>
          <tr><td style="padding: 8px;">[Entity Name]</td><td style="padding: 8px;">[Waste Type – Activity Type = Waste]</td><td style="padding: 8px; text-align: right;">45,000</td><td style="padding: 8px;">tonnes</td><td style="padding: 8px;">[Period Start]</td><td style="padding: 8px;">[Period End]</td></tr>
          <tr style="background-color: #fafafa;"><td style="padding: 8px;">[Entity Name]</td><td style="padding: 8px;">[Waste Type – Activity Type = Waste]</td><td style="padding: 8px; text-align: right;">12,500</td><td style="padding: 8px;">tonnes</td><td style="padding: 8px;">[Period Start]</td><td style="padding: 8px;">[Period End]</td></tr>
          <tr><td style="padding: 8px;">[Entity Name]</td><td style="padding: 8px;">[Waste Type – Activity Type = Waste]</td><td style="padding: 8px; text-align: right;">38,000</td><td style="padding: 8px;">tonnes</td><td style="padding: 8px;">[Period Start]</td><td style="padding: 8px;">[Period End]</td></tr>
          <tr style="background-color: #fafafa;"><td style="padding: 8px;">[Entity Name]</td><td style="padding: 8px;">[Waste Type – Activity Type = Waste]</td><td style="padding: 8px; text-align: right;">3,200</td><td style="padding: 8px;">tonnes</td><td style="padding: 8px;">[Period Start]</td><td style="padding: 8px;">[Period End]</td></tr>
        </tbody>
      </table>

      <h4>ESRS 2 – General Disclosures</h4>
      <p><strong>Organisational Boundary</strong></p>
      <table border="1" style="width: 100%; border-collapse: collapse; margin: 16px 0; font-size: 0.9em;">
        <thead>
          <tr style="background-color: #f3f3f5;">
            <th style="padding: 8px;">Level 1</th>
            <th style="padding: 8px;">Level 2</th>
            <th style="padding: 8px;">Level 3</th>
          </tr>
        </thead>
        <tbody>
          <tr><td style="padding: 8px;" rowspan="3">Head Entity Name</td><td style="padding: 8px;" rowspan="3">Entity A</td><td style="padding: 8px;">Entity A1</td></tr>
          <tr><td style="padding: 8px;">Entity A2</td></tr>
          <tr><td style="padding: 8px;">Entity A3</td></tr>
          <tr style="background-color: #fafafa;"><td style="padding: 8px;"></td><td style="padding: 8px;" rowspan="2">Entity B</td><td style="padding: 8px;">Entity B1</td></tr>
          <tr style="background-color: #fafafa;"><td style="padding: 8px;"></td><td style="padding: 8px;">Entity B2</td></tr>
          <tr><td style="padding: 8px;"></td><td style="padding: 8px;" rowspan="6">Entity C</td><td style="padding: 8px;">Entity C1</td></tr>
          <tr><td style="padding: 8px;"></td><td style="padding: 8px;">Entity C2</td></tr>
          <tr><td style="padding: 8px;"></td><td style="padding: 8px;">Entity C3</td></tr>
          <tr><td style="padding: 8px;"></td><td style="padding: 8px;">Entity C4</td></tr>
          <tr><td style="padding: 8px;"></td><td style="padding: 8px;">Entity C5</td></tr>
          <tr><td style="padding: 8px;"></td><td style="padding: 8px;">Entity C6</td></tr>
        </tbody>
      </table>

      <p><strong>Site Inventory</strong></p>
      <table border="1" style="width: 100%; border-collapse: collapse; margin: 16px 0; font-size: 0.9em;">
        <thead>
          <tr style="background-color: #f3f3f5;">
            <th style="padding: 8px;">Site</th>
            <th style="padding: 8px;">Site Description</th>
            <th style="padding: 8px;">Activities</th>
            <th style="padding: 8px;">Assets</th>
          </tr>
        </thead>
        <tbody>
          <tr><td style="padding: 8px;">Head Entity Name</td><td style="padding: 8px;">[Entity Description]</td><td style="padding: 8px;">[List of EPS names assigned to this entity]</td><td style="padding: 8px;">[List of Asset names assigned to this entity]</td></tr>
          <tr style="background-color: #fafafa;"><td style="padding: 8px;">Entity A</td><td style="padding: 8px;">[Entity Description]</td><td style="padding: 8px;">[List of EPS names assigned to this entity]</td><td style="padding: 8px;">[List of Asset names assigned to this entity]</td></tr>
          <tr><td style="padding: 8px;">Entity B</td><td style="padding: 8px;">[Entity Description]</td><td style="padding: 8px;">[List of EPS names assigned to this entity]</td><td style="padding: 8px;">[List of Asset names assigned to this entity]</td></tr>
        </tbody>
      </table>

      <h4>Calculation Methodology</h4>
      <p>Adapting principles from DEFRA, all conversion factors cited above are in units of 'tonnes of carbon dioxide equivalent of Y per X' (tCO₂e of Y per X), where Y is the gas emitted and X is the unit activity. In CarbonView, all GHGs, Y, are represented in units of CO₂e. CO₂e is the universal unit of measurement to indicate the global warming potential (GWP) of GHGs, expressed in terms of the GWP of one unit of carbon dioxide. The calculation method is as follows:</p>
      <p><strong>GHG emissions = activity data × emission conversion factor</strong></p>
      <p><strong>Methodology notes:</strong> ${findFieldValue(sections, 'methodology-notes', '[USER INPUT → details]')}</p>
      <p><strong>Glossary:</strong> ${findFieldValue(sections, 'glossary', '[USER INPUT → terms]')}</p>
    `;
  }

  // TCFD / TCFD-SAMPLE-2
  return `
    <h1>${reportName || '[CARBONVIEW INPUT → Organisation Name]'}</h1>
    <h2 style="color: #0B64B3;">TCFD Report</h2>
    <p><strong>Reporting Year:</strong> ${reportingPeriod || '[USER INPUT → Start Date – End Date]'}</p>

    <h3>1. Introduction</h3>
    <p>${reportName || '[CARBONVIEW INPUT → Organisation Name]'} presents this climate-related financial disclosure in accordance with the TCFD framework.</p>
    <p>This report covers:</p>
    <ul>
      <li>Governance</li>
      <li>Strategy</li>
      <li>Risk Management</li>
      <li>Metrics &amp; Targets</li>
    </ul>
    <p><strong>Reporting boundary:</strong> ${findFieldValue(sections, 'reporting-boundary', '[USER INPUT → e.g., Group / UK Operations / Global Operations]')}</p>
    <p><strong>Scenario coverage year:</strong> ${findFieldValue(sections, 'scenario-year', '[USER INPUT → Year]')}</p>
    <p>CarbonView is used to support emissions data consolidation and performance reporting where possible.</p>

    <h3>2. Pillar 1 — Governance</h3>

    <h4>2.1 Board Oversight</h4>
    <p>${findFieldValue(sections, 'board-oversight', '[USER INPUT →]')}</p>
    <p><strong>Frequency of review:</strong> ${findFieldValue(sections, 'review-frequency', '[USER INPUT → e.g., Quarterly / Bi-annually]')}</p>

    <h4>2.2 Management's Role</h4>
    <p>Management responsibility is assigned to:</p>
    <p>${findFieldValue(sections, 'management-role', '[USER INPUT → Role titles, e.g., Sustainability Lead, COO, ESG Manager]')}</p>

    <h4>2.3 Governance Structure</h4>
    <p>Org chart or governance diagram: ${findFieldValue(sections, 'governance-structure', '[USER INPUT → Insert or describe governance diagram]')}</p>

    <h3>3. Pillar 2 — Strategy</h3>

    <h4>3.1 Climate-Related Risks &amp; Opportunities</h4>
    <table border="1" style="width: 100%; border-collapse: collapse; margin: 16px 0;">
      <thead>
        <tr style="background-color: #f3f3f5;">
          <th style="padding: 12px; text-align: left;">Category</th>
          <th style="padding: 12px; text-align: left;">Description</th>
          <th style="padding: 12px; text-align: left;">Time Horizon</th>
          <th style="padding: 12px; text-align: left;">Financial Impact</th>
          <th style="padding: 12px; text-align: left;">Supporting Data</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="padding: 12px;">Transition Risks</td>
          <td style="padding: 12px;">${findFieldValue(sections, 'transition-risks-desc', '[USER INPUT → Describe transition risks]')}</td>
          <td style="padding: 12px;">${findFieldValue(sections, 'transition-risks-time', '[USER INPUT]')}</td>
          <td style="padding: 12px;">${findFieldValue(sections, 'transition-risks-impact', '[USER INPUT]')}</td>
          <td style="padding: 12px;">${findFieldValue(sections, 'transition-risks-supporting-data', '[USER INPUT → Emissions/Energy Baselines]')}</td>
        </tr>
        <tr style="background-color: #fafafa;">
          <td style="padding: 12px;">Physical Risks</td>
          <td style="padding: 12px;">${findFieldValue(sections, 'physical-risks-desc', '[USER INPUT → Describe physical risks]')}</td>
          <td style="padding: 12px;">${findFieldValue(sections, 'physical-risks-time', '[USER INPUT]')}</td>
          <td style="padding: 12px;">${findFieldValue(sections, 'physical-risks-impact', '[USER INPUT]')}</td>
          <td style="padding: 12px;">${findFieldValue(sections, 'physical-risks-supporting-data', '[USER INPUT → Physical risk data source]')}</td>
        </tr>
        <tr>
          <td style="padding: 12px;">Opportunities</td>
          <td style="padding: 12px;">${findFieldValue(sections, 'opportunities-desc', '[USER INPUT → Efficiency/low-carbon opportunities]')}</td>
          <td style="padding: 12px;">${findFieldValue(sections, 'opportunities-time', '[USER INPUT]')}</td>
          <td style="padding: 12px;">${findFieldValue(sections, 'opportunities-impact', '[USER INPUT]')}</td>
          <td style="padding: 12px;">${findFieldValue(sections, 'opportunities-supporting-data', '[USER INPUT → Energy reduction / project data]')}</td>
        </tr>
      </tbody>
    </table>

    <h4>3.3 Impact on Business &amp; Strategy</h4>
    <p>Summary of business impacts: ${findFieldValue(sections, 'business-impact', '[USER INPUT → Business model impacts]')}</p>

    <h4>3.4 Scenario Analysis</h4>
    <p>${findFieldValue(sections, 'scenario-analysis', '[USER INPUT →]')}</p>
    <p><strong>Key variables included:</strong> ${findFieldValue(sections, 'scenario-variables', '[USER INPUT → Carbon price, heat exposure, transition costs]')}</p>
    <p><strong>Summary of results:</strong> ${findFieldValue(sections, 'scenario-results', '[USER INPUT → Qualitative or quantitative outputs]')}</p>

    <h3>4. Pillar 3 — Risk Management</h3>

    <h4>4.1 Identification &amp; Assessment</h4>
    <p>Climate risks are integrated into:</p>
    <p>${findFieldValue(sections, 'risk-identification', '[USER INPUT → e.g., enterprise risk management framework]')}</p>

    <h4>4.2 Management of Climate Risks</h4>
    <p>Controls in place: ${findFieldValue(sections, 'risk-management-controls', '[USER INPUT → e.g., building resilience measures, energy plans]')}</p>

    <h4>4.3 Integration with Overall Risk Framework</h4>
    <p>Links to risk register: ${findFieldValue(sections, 'risk-integration', '[USER INPUT → Describe integration]')}</p>

    <h3>5. Pillar 4 — Metrics &amp; Targets</h3>

    <h4>5.1 Greenhouse Gas Emissions (tCO₂e)</h4>
    <p>(CarbonView populates all emissions)</p>
    <table border="1" style="width: 100%; border-collapse: collapse; margin: 16px 0;">
      <thead>
        <tr style="background-color: #f3f3f5;">
          <th style="padding: 12px; text-align: left;">Category</th>
          <th style="padding: 12px; text-align: right;">Value</th>
          <th style="padding: 12px; text-align: left;">Source</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="padding: 12px;">Scope 1</td>
          <td style="padding: 12px; text-align: right;">${token('46.2 tCO₂e', 'scope1-total', 'Estimated')}</td>
          <td style="padding: 12px;">CarbonView</td>
        </tr>
        <tr style="background-color: #fafafa;">
          <td style="padding: 12px;">Scope 2</td>
          <td style="padding: 12px; text-align: right;">${token('462 tCO₂e', 'scope2-total')}</td>
          <td style="padding: 12px;">CarbonView</td>
        </tr>
        <tr>
          <td style="padding: 12px;">Scope 3</td>
          <td style="padding: 12px; text-align: right;">${token('280 tCO₂e', 'scope3-total', 'Estimated')}</td>
          <td style="padding: 12px;">CarbonView</td>
        </tr>
        <tr style="background-color: #f3f3f5; font-weight: bold;">
          <td style="padding: 12px;">Total</td>
          <td style="padding: 12px; text-align: right;">${token('788.2 tCO₂e', 'total-emissions')}</td>
          <td style="padding: 12px;">CarbonView</td>
        </tr>
      </tbody>
    </table>

    <h4>5.2 Energy Consumption</h4>
    <table border="1" style="width: 100%; border-collapse: collapse; margin: 16px 0;">
      <thead>
        <tr style="background-color: #f3f3f5;">
          <th style="padding: 12px; text-align: left;">Category</th>
          <th style="padding: 12px; text-align: right;">kWh</th>
          <th style="padding: 12px; text-align: left;">Source</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="padding: 12px;">
            Electricity
            <br/><em style="color: #666; font-size: 0.9em;">Activity Type = Electricity Use (General), except Solar PV Generation</em>
          </td>
          <td style="padding: 12px; text-align: right;">${token('892,500', 'electricity-kwh')}</td>
          <td style="padding: 12px;">CarbonView</td>
        </tr>
        <tr style="background-color: #fafafa;">
          <td style="padding: 12px;">
            Gas
            <br/><em style="color: #666; font-size: 0.9em;">Activity Type = Fuel Combustion (LNG, Natural Gas (General), Natural Gas (HVAC), Propane, Other Combustible Gases) with unit = kWh</em>
          </td>
          <td style="padding: 12px; text-align: right;">${token('163,800', 'gas-kwh', 'Estimated')}</td>
          <td style="padding: 12px;">CarbonView</td>
        </tr>
        <tr>
          <td style="padding: 12px;">
            Transport Fuel
            <br/><em style="color: #666; font-size: 0.9em;">Activity Type = Fuel Combustion (Diesel, LNG, Biodiesel, Gasoline, Natural Gas (General), Propane) with unit = kWh</em>
          </td>
          <td style="padding: 12px; text-align: right;">${token('125,000', 'transport-fuel-kwh', 'Estimated')}</td>
          <td style="padding: 12px;">CarbonView</td>
        </tr>
      </tbody>
    </table>

    <h4>5.3 Intensity Metrics</h4>
    <p>Required by TCFD:</p>
    <p><strong>Selected metric:</strong> ${findFieldValue(sections, 'intensity-metric', '[USER INPUT → e.g., tCO₂e per FTE / revenue / m²]')}</p>
    <p><strong>Result:</strong> ${token('3.2 tCO₂e per FTE', 'intensity-value')}</p>
    <p><strong>YOY change:</strong> ${token('-8.5 %', 'intensity-yoy-change')}</p>

    <h4>5.4 Targets</h4>
    <p><strong>Net Zero commitment:</strong> ${findFieldValue(sections, 'net-zero-commitment', '[USER INPUT → e.g., Net Zero by 2050? Yes/No]')}</p>
    <p><strong>Interim targets:</strong> ${findFieldValue(sections, 'interim-targets-reduction', '[USER INPUT → Target reduction %]')}% reduction by ${findFieldValue(sections, 'interim-targets-year', '[USER INPUT → Target year]')}</p>
    <p><strong>Current performance vs target:</strong> ${token('On track: 20% achieved by 2025', 'progress-tracking')}</p>

    <h3>6. Additional Disclosures</h3>

    <h4>6.1 Methodology Notes</h4>
    <p><strong>Conversion factors:</strong> ${token('DEFRA UK Government Conversion Factors 2023', 'conversion-factors')}</p>
    <p><strong>Boundaries &amp; assumptions:</strong></p>
    <p>${findFieldValue(sections, 'boundaries-assumptions', '[USER INPUT → Operational boundaries, exclusions]')}</p>

    <h4>6.2 Limitations</h4>
    <p><strong>Data gaps:</strong> ${findFieldValue(sections, 'data-gaps', '[USER INPUT → Describe Scope 3 or supplier gaps]')}</p>
    <p><strong>Estimation methods:</strong> ${findFieldValue(sections, 'estimation-methods', '[USER INPUT]')}</p>

    <h4>6.3 Forward-Looking Statements</h4>
    <p>${findFieldValue(sections, 'forward-looking-statement', '[USER INPUT → Standard caution wording]')}</p>

    <h3>7. Appendix</h3>

    <h4>7.1 Detailed GHG Tables</h4>
    <p>${token('Activity data, emission factors, calculation outputs from CarbonView', 'detailed-ghg-tables')}</p>
    <table border="1" style="width: 100%; border-collapse: collapse; margin: 16px 0; font-size: 0.9em;">
      <thead>
        <tr style="background-color: #f3f3f5;">
          <th style="padding: 8px; text-align: left;">Scope</th>
          <th style="padding: 8px; text-align: left;">Entity</th>
          <th style="padding: 8px; text-align: left;">Activity Category</th>
          <th style="padding: 8px; text-align: right;">Contribution</th>
          <th style="padding: 8px; text-align: left;">Unit</th>
          <th style="padding: 8px; text-align: left;">Emission Factor</th>
          <th style="padding: 8px; text-align: left;">Source</th>
          <th style="padding: 8px; text-align: right;">CO₂e (t)</th>
          <th style="padding: 8px; text-align: left;">Periods</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="padding: 8px;">1</td>
          <td style="padding: 8px;">[Entity Name]</td>
          <td style="padding: 8px;">[Individual EPS assigned to the Entity]</td>
          <td style="padding: 8px; text-align: right;">12,000</td>
          <td style="padding: 8px;">L</td>
          <td style="padding: 8px;">2.68 tCO₂e/L</td>
          <td style="padding: 8px;">[Description of the EPS]</td>
          <td style="padding: 8px; text-align: right;">32,160</td>
          <td style="padding: 8px;">[Periods]</td>
        </tr>
        <tr style="background-color: #fafafa;">
          <td style="padding: 8px;">1</td>
          <td style="padding: 8px;">[Entity Name]</td>
          <td style="padding: 8px;">[Individual EPS assigned to the Entity]</td>
          <td style="padding: 8px; text-align: right;">45,000</td>
          <td style="padding: 8px;">kWh</td>
          <td style="padding: 8px;">0.233 tCO₂e/kWh</td>
          <td style="padding: 8px;">[Description of the EPS]</td>
          <td style="padding: 8px; text-align: right;">10,485</td>
          <td style="padding: 8px;">[Periods]</td>
        </tr>
        <tr>
          <td style="padding: 8px;">2</td>
          <td style="padding: 8px;">[Entity Name]</td>
          <td style="padding: 8px;">[Individual EPS assigned to the Entity]</td>
          <td style="padding: 8px; text-align: right;">85,000</td>
          <td style="padding: 8px;">kWh</td>
          <td style="padding: 8px;">0.233 tCO₂e/kWh</td>
          <td style="padding: 8px;">[Description of the EPS]</td>
          <td style="padding: 8px; text-align: right;">19,805</td>
          <td style="padding: 8px;">[Periods]</td>
        </tr>
        <tr style="background-color: #fafafa;">
          <td style="padding: 8px;">2</td>
          <td style="padding: 8px;">[Entity Name]</td>
          <td style="padding: 8px;">[Individual EPS assigned to the Entity]</td>
          <td style="padding: 8px; text-align: right;">92,087</td>
          <td style="padding: 8px;">km</td>
          <td style="padding: 8px;">0.15 tCO₂e/km</td>
          <td style="padding: 8px;">[Description of the EPS]</td>
          <td style="padding: 8px; text-align: right;">13,813</td>
          <td style="padding: 8px;">[Periods]</td>
        </tr>
        <tr>
          <td style="padding: 8px;">3</td>
          <td style="padding: 8px;">[Entity Name]</td>
          <td style="padding: 8px;">[Individual EPS assigned to the Entity]</td>
          <td style="padding: 8px; text-align: right;">54,000</td>
          <td style="padding: 8px;">km</td>
          <td style="padding: 8px;">0.15 tCO₂e/km</td>
          <td style="padding: 8px;">[Description of the EPS]</td>
          <td style="padding: 8px; text-align: right;">8,100</td>
          <td style="padding: 8px;">[Periods]</td>
        </tr>
        <tr style="background-color: #fafafa;">
          <td style="padding: 8px;">3</td>
          <td style="padding: 8px;">[Entity Name]</td>
          <td style="padding: 8px;">[Individual EPS assigned to the Entity]</td>
          <td style="padding: 8px; text-align: right;">420</td>
          <td style="padding: 8px;">m³</td>
          <td style="padding: 8px;">1.85 tCO₂e/ton</td>
          <td style="padding: 8px;">[Description of the EPS]</td>
          <td style="padding: 8px; text-align: right;">777</td>
          <td style="padding: 8px;">[Periods]</td>
        </tr>
      </tbody>
    </table>

    <h4>7.2 Additional Scenario Details</h4>
    <p>Inputs &amp; assumptions: ${findFieldValue(sections, 'scenario-inputs', '[USER INPUT]')}</p>

    <h4>7.3 Governance Chart</h4>
    <p>Insert visual or description: ${findFieldValue(sections, 'governance-chart', '[USER INPUT]')}</p>
  `;
};
